.button {
  --btn-icon-default-height: 32px;
  --btn-icon-default-border-radius: 999px;
  --btn-icon-default-padding-x: 0;
  --btn-icon-padding: 0;

  position: absolute;
  top: 12px;
  right: 12px;
  background: var(--colors-grays-white);
  border: 1px solid var(--colors-transparent-black-ten);
  box-shadow: var(--shadows-drop);

  /*
    Safari stops repainting this control on slides that promote no layer of their
    own, so it goes missing until a hover dirties it
  */
  transform: translateZ(0);
  z-index: 1;
}

.button:is(:hover, :focus-visible) {
  background: var(--colors-grays-white);
}

.icon {
  width: 12px;
  height: 12px;
}

@media all and (--reefer-media-tablet-min) {
  .button {
    --btn-icon-default-height: 40px;

    top: 16px;
    right: 16px;
  }

  .icon {
    width: var(--icon-sizes-sm);
    height: var(--icon-sizes-sm);
  }
}
